import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const ActionButton = styled(Button)(({ theme }) => ({
    minWidth: '32px',
    width: '34px',
    height: '34px',
    padding: 0,
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.action.hover,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
      transform: 'translateY(-1px)',
      boxShadow: '0 3px 6px rgba(0,0,0,0.15)',
    }
  }));

export default ActionButton;